import { IncomeIntervalType } from '@upstart/harmony/lib/legos/constants';
import { isNil } from 'lodash';
import React from 'react';
import { CreditFormConfig } from '@upstart/harmony/lib/legos/dealerTypes';
import { Radio } from '../../components/GlobalUI';
import './IncomeIntervalSelect.scss';
import Tooltip from '../../components/Tooltip';

interface IncomeIntervalSelectProps {
  creditFormConfig: CreditFormConfig;
  setCreditFormConfig: (config: CreditFormConfig) => void;
}

export const IncomeIntervalSelect = ({
  creditFormConfig,
  setCreditFormConfig,
}: IncomeIntervalSelectProps) => (
  <div className="income-interval-container">
    <div className="income-interval-header">
      <span className="income-interval-title">Income Interval Type</span>
      <Tooltip
        width={250}
        text="This will apply for both primary income and other income fields for applicant and co-applicant. "
      >
        <i className="glyphicon glyphicon-info-sign" />
      </Tooltip>
    </div>
    <Radio
      containerClassName=""
      label="Annual"
      checked={
        creditFormConfig.incomeIntervalType === IncomeIntervalType.ANNUAL ||
        isNil(creditFormConfig.incomeIntervalType)
      }
      onChange={() =>
        setCreditFormConfig({
          ...creditFormConfig,
          incomeIntervalType: IncomeIntervalType.ANNUAL,
        })
      }
    />
    <Radio
      containerClassName=""
      label="Monthly"
      checked={
        creditFormConfig.incomeIntervalType === IncomeIntervalType.MONTHLY
      }
      onChange={() =>
        setCreditFormConfig({
          ...creditFormConfig,
          incomeIntervalType: IncomeIntervalType.MONTHLY,
        })
      }
    />
  </div>
);
